(() => {
  if (window.__ctaAddToCartInit) return;
  window.__ctaAddToCartInit = true;

  function getShopifyRoot() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) return window.Shopify.routes.root;
    return "/";
  }

  function getAddUrl() {
    if (window.routes && routes.cart_add_url) return routes.cart_add_url;
    return `${getShopifyRoot()}cart/add.js`;
  }

  function getCartUrl() {
    if (window.routes && routes.cart_url) return routes.cart_url;
    return `${getShopifyRoot()}cart`;
  }

  function getFetchOptions(body) {
    if (typeof fetchConfig === "function") {
      const cfg = fetchConfig() || {};
      return { ...cfg, body };
    }

    return {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "same-origin",
      body,
    };
  }

  async function addToCart(variantId, quantity) {
    const payload = {
      items: [{ id: Number(variantId), quantity: Number(quantity || 1) }],
    };

    const res = await fetch(getAddUrl(), getFetchOptions(JSON.stringify(payload)));
    const data = await res.json().catch(() => null);

    const hasErrorStatus = data && typeof data.status === "number" && data.status >= 400;
    if (!res.ok || hasErrorStatus) {
      const message = (data && (data.description || data.message)) || "Add to cart failed";
      throw new Error(message);
    }

    return data;
  }

  function closeThemeDrawer() {
    const cartDrawerEl = document.querySelector("cart-drawer");
    if (cartDrawerEl && typeof cartDrawerEl.close === "function") cartDrawerEl.close();

    const drawer =
      document.getElementById("CartDrawer") ||
      document.querySelector(".cart-drawer");

    if (drawer) {
      drawer.classList.remove("is-open", "active", "open");
      drawer.removeAttribute("open");
    }
  }

  function openUpcartDrawer() {
    const upcartTrigger = document.querySelector(".js-upcart-open");
    if (upcartTrigger) {
      upcartTrigger.click();
      return true;
    }
    return false;
  }

  document.addEventListener(
    "click",
    async (e) => {
      const btn = e.target.closest("[data-cta-add-to-cart]");
      if (!btn) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const variantId = btn.getAttribute("data-variant-id");
      const quantity = btn.getAttribute("data-quantity") || 1;

      if (!variantId) return;

      btn.setAttribute("disabled", "disabled");
      btn.setAttribute("aria-busy", "true");

      try {
        await addToCart(variantId, quantity);

        const openThemeDrawer = btn.getAttribute("data-open-theme-drawer") === "true";

        if (openThemeDrawer) {
          closeThemeDrawer();
        } else {
          closeThemeDrawer(); 
          const opened = openUpcartDrawer();
          
        }
      } catch (err) {
        console.error(err);
      } finally {
        btn.removeAttribute("disabled");
        btn.removeAttribute("aria-busy");
      }
    },
    true
  );
})();
